import * as tokens from '../../../../../tokens/color.dark.generated.js';
export const componentColorDark = {
    color: {
        action: {
            iconButton: {
                foreground: {
                    text: {
                        default: tokens.CMP_COLOR_ACTION_ICON_BUTTON_FOREGROUND_TEXT_DEFAULT_DARK,
                        selected: tokens.CMP_COLOR_ACTION_ICON_BUTTON_FOREGROUND_TEXT_SELECTED_DARK,
                        hover: tokens.CMP_COLOR_ACTION_ICON_BUTTON_FOREGROUND_TEXT_HOVER_DARK,
                        pressed: tokens.CMP_COLOR_ACTION_ICON_BUTTON_FOREGROUND_TEXT_PRESSED_DARK,
                        disabled: tokens.CMP_COLOR_ACTION_ICON_BUTTON_FOREGROUND_TEXT_DISABLED_DARK
                    }
                }
            },
            componentButton: {
                foreground: {
                    icon: {
                        idle: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_FOREGROUND_ICON_IDLE_DARK,
                        hover: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_FOREGROUND_ICON_HOVER_DARK,
                        pressed: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_FOREGROUND_ICON_PRESSED_DARK,
                        disabled: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_FOREGROUND_ICON_DISABLED_DARK
                    }
                },
                surface: {
                    stroke: {
                        idle: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_SURFACE_STROKE_IDLE_DARK,
                        hover: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_SURFACE_STROKE_HOVER_DARK,
                        pressed: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_SURFACE_STROKE_PRESSED_DARK,
                        disabled: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_SURFACE_STROKE_DISABLED_DARK
                    },
                    fill: {
                        idle: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_SURFACE_FILL_IDLE_DARK,
                        hover: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_SURFACE_FILL_HOVER_DARK,
                        pressed: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_SURFACE_FILL_PRESSED_DARK,
                        disabled: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_SURFACE_FILL_DISABLED_DARK
                    }
                }
            }
        },
        feedback: {
            notification: {
                foreground: {
                    icon: {
                        default: tokens.CMP_COLOR_FEEDBACK_NOTIFICATION_FOREGROUND_ICON_DEFAULT_DARK
                    }
                }
            },
            progressIndicator: {
                foreground: {
                    text: {
                        default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_FOREGROUND_TEXT_DEFAULT_DARK,
                        inverted: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_FOREGROUND_TEXT_INVERTED_DARK,
                        range: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_FOREGROUND_TEXT_RANGE_DEFAULT_DARK
                        }
                    }
                },
                monochrome: {
                    surface: {
                        trainLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_MONOCHROME_SURFACE_TRAIN_LINE_DEFAULT_DARK
                        },
                        trackLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_MONOCHROME_SURFACE_TRACK_LINE_DEFAULT_DARK
                        }
                    }
                },
                inverted: {
                    surface: {
                        trainLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_INVERTED_SURFACE_TRAIN_LINE_DEFAULT_DARK
                        },
                        trackLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_INVERTED_SURFACE_TRACK_LINE_DEFAULT_DARK
                        }
                    }
                }
            }
        },
        ui: {
            avatar: {
                loggedIn: {
                    surface: {
                        fill: {
                            idle: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_SURFACE_FILL_IDLE_DARK,
                            interactive: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_SURFACE_FILL_INTERACTIVE_DARK,
                            selected: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_SURFACE_FILL_SELECTED_DARK,
                            disabled: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_SURFACE_FILL_DISABLED_DARK
                        },
                        stroke: {
                            idle: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_SURFACE_STROKE_IDLE_DARK,
                            interactive: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_SURFACE_STROKE_INTERACTIVE_DARK,
                            selected: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_SURFACE_STROKE_SELECTED_DARK,
                            disabled: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_SURFACE_STROKE_DISABLED_DARK
                        }
                    },
                    foreground: {
                        icons: {
                            idle: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_FOREGROUND_ICONS_IDLE_DARK,
                            interactive: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_FOREGROUND_ICONS_INTERACTIVE_DARK,
                            selected: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_FOREGROUND_ICONS_SELECTED_DARK,
                            disabled: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_FOREGROUND_ICONS_DISABLED_DARK
                        },
                        text: {
                            idle: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_FOREGROUND_TEXT_IDLE_DARK,
                            interactive: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_FOREGROUND_TEXT_INTERACTIVE_DARK,
                            selected: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_FOREGROUND_TEXT_SELECTED_DARK,
                            disabled: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_FOREGROUND_TEXT_DISABLED_DARK
                        }
                    },
                    image: {
                        surface: {
                            stroke: {
                                idle: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_IMAGE_SURFACE_STROKE_IDLE_DARK,
                                interactive: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_IMAGE_SURFACE_STROKE_INTERACTIVE_DARK,
                                selected: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_IMAGE_SURFACE_STROKE_SELECTED_DARK,
                                disabled: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_IMAGE_SURFACE_STROKE_DISABLED_DARK
                            },
                            imageStateLayer: {
                                fill: {
                                    idle: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_IMAGE_SURFACE_IMAGE_STATE_LAYER_FILL_IDLE_DARK,
                                    interactive: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_IMAGE_SURFACE_IMAGE_STATE_LAYER_FILL_INTERACTIVE_DARK,
                                    selected: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_IMAGE_SURFACE_IMAGE_STATE_LAYER_FILL_SELECTED_DARK,
                                    disabled: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_IMAGE_SURFACE_IMAGE_STATE_LAYER_FILL_DISABLED_DARK
                                }
                            }
                        }
                    }
                },
                loggedOut: {
                    surface: {
                        fill: {
                            idle: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_SURFACE_FILL_IDLE_DARK,
                            interactive: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_SURFACE_FILL_INTERACTIVE_DARK,
                            selected: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_SURFACE_FILL_SELECTED_DARK,
                            disabled: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_SURFACE_FILL_DISABLED_DARK
                        },
                        stroke: {
                            idle: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_SURFACE_STROKE_IDLE_DARK,
                            interactive: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_SURFACE_STROKE_INTERACTIVE_DARK,
                            selected: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_SURFACE_STROKE_SELECTED_DARK,
                            disabled: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_SURFACE_STROKE_DISABLED_DARK
                        }
                    },
                    foreground: {
                        icons: {
                            idle: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_FOREGROUND_ICONS_IDLE_DARK,
                            interactive: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_FOREGROUND_ICONS_INTERACTIVE_DARK,
                            selected: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_FOREGROUND_ICONS_SELECTED_DARK,
                            disabled: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_FOREGROUND_ICONS_DISABLED_DARK
                        }
                    }
                }
            },
            skeleton: {
                surface: {
                    fill: tokens.CMP_COLOR_UI_SKELETON_SURFACE_FILL_DARK
                }
            },
            table: {
                foreground: {
                    text: {
                        title: {
                            default: tokens.CMP_COLOR_UI_TABLE_FOREGROUND_TEXT_TITLE_DEFAULT_DARK
                        },
                        headline: {
                            default: tokens.CMP_COLOR_UI_TABLE_FOREGROUND_TEXT_HEADLINE_DEFAULT_DARK
                        },
                        copy: {
                            default: tokens.CMP_COLOR_UI_TABLE_FOREGROUND_TEXT_COPY_DEFAULT_DARK
                        }
                    },
                    divider: {
                        default: tokens.CMP_COLOR_UI_TABLE_FOREGROUND_DIVIDER_DEFAULT_DARK
                    }
                },
                surface: {
                    fill: {
                        default: tokens.CMP_COLOR_UI_TABLE_SURFACE_FILL_DEFAULT_DARK
                    }
                }
            },
            value: {
                foreground: {
                    text: {
                        label: tokens.CMP_COLOR_UI_VALUE_FOREGROUND_TEXT_LABEL_DARK,
                        caption: tokens.CMP_COLOR_UI_VALUE_FOREGROUND_TEXT_CAPTION_DARK
                    }
                }
            },
            tag: {
                readOnly: {
                    icon: {
                        default: tokens.CMP_COLOR_UI_TAG_READ_ONLY_ICON_DEFAULT_DARK
                    },
                    text: {
                        default: tokens.CMP_COLOR_UI_TAG_READ_ONLY_TEXT_DEFAULT_DARK
                    },
                    surface: {
                        fill: {
                            default: tokens.CMP_COLOR_UI_TAG_READ_ONLY_SURFACE_FILL_DEFAULT_DARK
                        },
                        stroke: {
                            default: tokens.CMP_COLOR_UI_TAG_READ_ONLY_SURFACE_STROKE_DEFAULT_DARK
                        }
                    }
                },
                unselected: {
                    surface: {
                        fill: {
                            default: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_DEFAULT_DARK,
                            interactive: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_INTERACTIVE_DARK,
                            disabled: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_DISABLED_DARK,
                            encourage: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_ENCOURAGE_DARK
                        },
                        stroke: {
                            default: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_DEFAULT_DARK,
                            interactive: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_INTERACTIVE_DARK,
                            disabled: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_DISABLED_DARK,
                            encourage: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_ENCOURAGE_DARK
                        }
                    },
                    text: {
                        default: tokens.CMP_COLOR_UI_TAG_UNSELECTED_TEXT_DEFAULT_DARK,
                        interactive: tokens.CMP_COLOR_UI_TAG_UNSELECTED_TEXT_INTERACTIVE_DARK,
                        disabled: tokens.CMP_COLOR_UI_TAG_UNSELECTED_TEXT_DISABLED_DARK,
                        encourage: tokens.CMP_COLOR_UI_TAG_UNSELECTED_TEXT_ENCOURAGE_DARK
                    },
                    icon: {
                        default: tokens.CMP_COLOR_UI_TAG_UNSELECTED_ICON_DEFAULT_DARK,
                        interactive: tokens.CMP_COLOR_UI_TAG_UNSELECTED_ICON_INTERACTIVE_DARK,
                        disabled: tokens.CMP_COLOR_UI_TAG_UNSELECTED_ICON_DISABLED_DARK,
                        encourage: tokens.CMP_COLOR_UI_TAG_UNSELECTED_ICON_ENCOURAGE_DARK
                    }
                },
                selected: {
                    surface: {
                        fill: {
                            default: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_DEFAULT_DARK,
                            interactive: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_INTERACTIVE_DARK,
                            disabled: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_DISABLED_DARK
                        },
                        stroke: {
                            default: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_STROKE_DEFAULT_DARK,
                            interactive: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_STROKE_INTERACTIVE_DARK,
                            disabled: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_STROKE_DISABLED_DARK
                        }
                    },
                    text: {
                        default: tokens.CMP_COLOR_UI_TAG_SELECTED_TEXT_DEFAULT_DARK,
                        interactive: tokens.CMP_COLOR_UI_TAG_SELECTED_TEXT_INTERACTIVE_DARK,
                        disabled: tokens.CMP_COLOR_UI_TAG_SELECTED_TEXT_DISABLED_DARK
                    },
                    icon: {
                        default: tokens.CMP_COLOR_UI_TAG_SELECTED_ICON_DEFAULT_DARK,
                        interactive: tokens.CMP_COLOR_UI_TAG_SELECTED_ICON_INTERACTIVE_DARK,
                        disabled: tokens.CMP_COLOR_UI_TAG_SELECTED_ICON_DISABLED_DARK
                    }
                }
            },
            productCard: {
                surface: {
                    fill: {
                        default: tokens.CMP_COLOR_UI_PRODUCT_CARD_SURFACE_FILL_DEFAULT_DARK
                    },
                    stroke: {
                        default: tokens.CMP_COLOR_UI_PRODUCT_CARD_SURFACE_STROKE_DEFAULT_DARK
                    }
                }
            },
            productTile: {
                surface: {
                    fill: {
                        default: tokens.CMP_COLOR_UI_PRODUCT_TILE_SURFACE_FILL_DEFAULT_DARK
                    },
                    stroke: {
                        default: tokens.CMP_COLOR_UI_PRODUCT_TILE_SURFACE_STROKE_DEFAULT_DARK
                    }
                }
            },
            accordion: {
                surface: {
                    idle: tokens.CMP_COLOR_UI_ACCORDION_SURFACE_IDLE_DARK,
                    disabled: tokens.CMP_COLOR_UI_ACCORDION_SURFACE_DISABLED_DARK,
                    focus: tokens.CMP_COLOR_UI_ACCORDION_SURFACE_FOCUS_DARK,
                    interactive: tokens.CMP_COLOR_UI_ACCORDION_SURFACE_INTERACTIVE_DARK
                }
            }
        },
        navigation: {
            tabs: {
                foreground: {
                    icon: {
                        default: tokens.CMP_COLOR_NAVIGATION_TABS_FOREGROUND_ICON_DEFAULT_DARK,
                        disabled: tokens.CMP_COLOR_NAVIGATION_TABS_FOREGROUND_ICON_DISABLED_DARK,
                        interactive: tokens.CMP_COLOR_NAVIGATION_TABS_FOREGROUND_ICON_INTERACTIVE_DARK,
                        active: tokens.CMP_COLOR_NAVIGATION_TABS_FOREGROUND_ICON_ACTIVE_DARK
                    },
                    text: {
                        default: tokens.CMP_COLOR_NAVIGATION_TABS_FOREGROUND_TEXT_DEFAULT_DARK,
                        disabled: tokens.CMP_COLOR_NAVIGATION_TABS_FOREGROUND_TEXT_DISABLED_DARK,
                        interactive: tokens.CMP_COLOR_NAVIGATION_TABS_FOREGROUND_TEXT_INTERACTIVE_DARK,
                        active: tokens.CMP_COLOR_NAVIGATION_TABS_FOREGROUND_TEXT_ACTIVE_DARK
                    }
                },
                surface: {
                    stroke: {
                        default: tokens.CMP_COLOR_NAVIGATION_TABS_SURFACE_STROKE_DEFAULT_DARK,
                        disabled: tokens.CMP_COLOR_NAVIGATION_TABS_SURFACE_STROKE_DISABLED_DARK,
                        interactive: tokens.CMP_COLOR_NAVIGATION_TABS_SURFACE_STROKE_INTERACTIVE_DARK,
                        active: tokens.CMP_COLOR_NAVIGATION_TABS_SURFACE_STROKE_ACTIVE_DARK
                    },
                    fill: {
                        default: tokens.CMP_COLOR_NAVIGATION_TABS_SURFACE_FILL_DEFAULT_DARK,
                        disabled: tokens.CMP_COLOR_NAVIGATION_TABS_SURFACE_FILL_DISABLED_DARK,
                        interactive: tokens.CMP_COLOR_NAVIGATION_TABS_SURFACE_FILL_INTERACTIVE_DARK,
                        active: tokens.CMP_COLOR_NAVIGATION_TABS_SURFACE_FILL_ACTIVE_DARK
                    }
                }
            },
            textLink: {
                foreground: {
                    default: tokens.CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_DEFAULT_DARK,
                    interactive: tokens.CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_INTERACTIVE_DARK,
                    disabled: tokens.CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_DISABLED_DARK
                }
            }
        },
        forms: {
            slider: {
                surface: {
                    track: {
                        default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_TRACK_DEFAULT_DARK
                    },
                    progress: {
                        default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_DEFAULT_DARK,
                        interactive: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_INTERACTIVE_DARK,
                        disabled: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_DISABLED_DARK,
                        error: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_ERROR_DARK
                    },
                    handle: {
                        fill: {
                            default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_FILL_DEFAULT_DARK,
                            disabled: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_FILL_DISABLED_DARK,
                            error: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_FILL_ERROR_DARK
                        },
                        stroke: {
                            default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_STROKE_DEFAULT_DARK,
                            disabled: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_STROKE_DISABLED_DARK,
                            error: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_STROKE_ERROR_DARK
                        }
                    }
                }
            },
            listItem: {
                surface: {
                    fill: {
                        default: tokens.CMP_COLOR_FORMS_LIST_ITEM_SURFACE_FILL_DEFAULT_DARK,
                        interactive: tokens.CMP_COLOR_FORMS_LIST_ITEM_SURFACE_FILL_INTERACTIVE_DARK
                    }
                }
            },
            extendedSelection: {
                surface: {
                    fill: {
                        default: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_FILL_DEFAULT_DARK,
                        active: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_FILL_ACTIVE_DARK
                    },
                    stroke: {
                        default: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_STROKE_DEFAULT_DARK,
                        active: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_STROKE_ACTIVE_DARK
                    }
                }
            },
            toggle: {
                inactive: {
                    surface: {
                        fill: {
                            default: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_FILL_DEFAULT_DARK,
                            interactive: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_FILL_INTERACTIVE_DARK,
                            disabled: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_FILL_DISABLED_DARK
                        },
                        stroke: {
                            default: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_STROKE_DEFAULT_DARK,
                            interactive: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_STROKE_INTERACTIVE_DARK,
                            disabled: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_STROKE_DISABLED_DARK
                        }
                    },
                    foreground: {
                        handle: {
                            fill: {
                                default: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_FOREGROUND_HANDLE_FILL_DEFAULT_DARK,
                                interactive: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_FOREGROUND_HANDLE_FILL_INTERACTIVE_DARK,
                                disabled: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_FOREGROUND_HANDLE_FILL_DISABLED_DARK
                            }
                        },
                        icon: {
                            default: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_FOREGROUND_ICON_DEFAULT_DARK,
                            interactive: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_FOREGROUND_ICON_INTERACTIVE_DARK,
                            disabled: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_FOREGROUND_ICON_DISABLED_DARK
                        }
                    }
                },
                active: {
                    surface: {
                        fill: {
                            default: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_SURFACE_FILL_DEFAULT_DARK,
                            interactive: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_SURFACE_FILL_INTERACTIVE_DARK,
                            disabled: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_SURFACE_FILL_DISABLED_DARK
                        },
                        stroke: {
                            default: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_SURFACE_STROKE_DEFAULT_DARK,
                            interactive: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_SURFACE_STROKE_INTERACTIVE_DARK,
                            disabled: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_SURFACE_STROKE_DISABLED_DARK
                        }
                    },
                    foreground: {
                        handle: {
                            fill: {
                                default: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_FOREGROUND_HANDLE_FILL_DEFAULT_DARK,
                                interactive: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_FOREGROUND_HANDLE_FILL_INTERACTIVE_DARK,
                                disabled: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_FOREGROUND_HANDLE_FILL_DISABLED_DARK
                            }
                        },
                        icon: {
                            default: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_FOREGROUND_ICON_DEFAULT_DARK,
                            interactive: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_FOREGROUND_ICON_INTERACTIVE_DARK,
                            disabled: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_FOREGROUND_ICON_DISABLED_DARK
                        }
                    }
                }
            }
        }
    }
};
//# sourceMappingURL=color.dark.js.map